import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { queryClient } from './queryClient';
import './styles/App.css';
import FaviconHead from './seo/FaviconHead';

const Home = lazy(() => import('./pages/Home'));
const Services = lazy(() => import('./pages/Services'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const Insights = lazy(() => import('./pages/Insights'));
const InsightPost = lazy(() => import('./pages/InsightPost'));
const MarketSignals = lazy(() => import('./pages/MarketSignals'));
const ApiPage = lazy(() => import('./pages/ApiPage'));
const ContactUs = lazy(() => import('./pages/ContactUs'));

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <div className="app">
          <FaviconHead />
          <Navbar />
          <main className="main-content">
            <Suspense fallback={null}>
              <Routes>
                <Route path="/"            element={<Home />} />
                <Route path="/services"    element={<Services />} />
                <Route path="/dashboard"   element={<Dashboard />} />
                <Route path="/signals"     element={<MarketSignals />} />
                <Route path="/signals/:id" element={<MarketSignals />} />
                <Route path="/insights/:slug" element={<InsightPost />} />
                <Route path="/insights" element={<Insights />} />
                <Route path="/api"         element={<ApiPage />} />
                <Route path="/contact"     element={<ContactUs />} />
              </Routes>
            </Suspense>
          </main>
          <Footer />
        </div>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
